
export class BasvuruKontrolDto {
    basvuruNumarasi:string;
    takipNumarasi:string; 
    
    public constructor() { }
}
